module.exports = __webpack_public_path__ + "img/reservation.ed4e8290.svg";